import ApplicationsMenu from "./ApplicationsMenu";

export default ApplicationsMenu;
